import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import TabIcon from '@mui/icons-material/Tab';

const DuplicateTabScreen = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        backgroundColor: 'var(--bg-color)',
        backgroundImage: 'url("/assets/abstract-background.svg")',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          p: 4,
          maxWidth: 480,
          width: '100%',
          borderRadius: 2,
          textAlign: 'center',
          backgroundColor: 'rgba(255,255,255,0.2)',
        }}
      >
        <TabIcon sx={{ fontSize: 56, color: 'primary.main' }} />

        <Typography variant="h6" fontWeight="bold" color="#fff">
          会话已在另一个标签页中打开
        </Typography>

        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
          此应用程序已在另一个标签页中运行。请切换回该标签页继续操作。
        </Typography>

        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.45)' }}>
          如果另一个标签页已关闭，请手动刷新。
        </Typography>

      </Paper>
    </Box>
  );
};

export default DuplicateTabScreen;
